// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3B4_X","title":"Info_title__2j2dY","selects":"Info_selects__1r-9f","requiredAsterisk":"Info_requiredAsterisk__2gvfX"};